import './ActionsPanel.css';

import RecentActivityPanel from './RecentActivityPanel';
import PointsExpiringPanel from './PointsExpiringPanel';
import UpgradeOpportunitiesPanel from './UpgradeOpportunitiesPanel';
import BroadcastComposer from './BroadcastComposer';

const ActionsPanel = () => (
  <div className="actions-grid" data-testid="actions-grid">
    <RecentActivityPanel />
    <PointsExpiringPanel />
    <UpgradeOpportunitiesPanel />
    <BroadcastComposer />
  </div>
);

export default ActionsPanel;
